/**
 * When a viewer should switch to the host's new song, and where in it to
 * start: they hear the host `delaySec` late, so a song the host is
 * `hostPosSec` into reaches them after the rest of that delay.
 */
export function planAudienceSwap({ hostPosSec, delaySec }) {
  const hostPos = Math.max(0, hostPosSec || 0);
  const waitSec = Math.max(0, delaySec - hostPos);
  return { waitSec, seedSec: Math.max(0, hostPos + waitSec - delaySec) };
}

/**
 * How far the host is into a song the viewer sees them change to. A change
 * seen while watching has only just happened, whatever the host's player
 * reports (an OBS dock reports the previous song's time for a moment). Only
 * a viewer's first song, when they join mid-song, uses the reported time.
 */
export function hostPositionForNewSong({ reportedSec, viewerHadSong }) {
  return viewerHadSong ? 0 : Math.max(0, reportedSec || 0);
}

/**
 * Whether a music-state update came from the host's player, which always
 * sends its playlist. The server used to send a bare "stopped" state at every
 * song end; a viewer that took it for the playlist dropped every song and
 * went silent until the real update arrived.
 */
export function carriesPlaylist(musicState) {
  return Array.isArray(musicState?.songs);
}
